export default [
	{
		path: "/pros/profile/edit-intro",
		exact: true,
		component: "EditProfileIntro/EditProfileIntro",
		mui: true,
	},
];
